export class Carrusel{
    id_carrusel	: string
    url_base_img : string
    slides_carrusel	: Slide[]
}

export class Slide {
    eqmorder : number
    filenamesave : string
    showseconds : number
    description	 : string
    url : string 
}
